import { render, staticRenderFns } from "./PlateMainChart.vue?vue&type=template&id=450ec75c&scoped=true&"
import script from "./PlateMainChart.vue?vue&type=script&lang=js&"
export * from "./PlateMainChart.vue?vue&type=script&lang=js&"
import style0 from "./PlateMainChart.vue?vue&type=style&index=0&id=450ec75c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ec75c",
  null
  
)

export default component.exports